import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScriptLoaderService {
  private readonly allowedOrigins = ['https://js.zuora.com'];
  private readonly loaded = new Map<string, Promise<void>>();

  load(src: string): Promise<void> {
    if (!src) {
      return Promise.reject(new Error("Empty script src"));
    }

    const url = new URL(src);
    if (!this.allowedOrigins.includes(`${url.origin}`)) {
      return Promise.reject(new Error("Disallowed script domain"));
    }

    if (this.loaded.has(src)) {
      return this.loaded.get(src);
    }

    const promise = new Promise<void>((resolve, reject) => {
      const el = document.createElement("script");
      el.src = src;
      el.async = true;
      el.onload = () => resolve();
      el.onerror = () => reject(new Error(`Failed to load script: ${src}`));
      document.head.appendChild(el);
    });

    this.loaded.set(src, promise);
    return promise;
  }
}
